// extracted by mini-css-extract-plugin
export default {"customSelect":"Age_customSelect__4sZhi"};